export default __webpack_public_path__ + "static/media/email.06277d54.svg";